export default __webpack_public_path__ + "static/media/Massiah Ahmed - Corporate Relations Associate.b99004e2.jpg";